import { CalculationActionDecorator, IExecutionPlanStep } from "./ExecutionPlanStep";

export class SimpleExecutionPlanStep implements IExecutionPlanStep {
    public toDebugString(): string {
        return "evaluate";
    }

    public getStepExecutor(): CalculationActionDecorator {
        return action => action;
    }
}
